module.exports = __webpack_public_path__ + "static/img/sfmhy_1.73b2d10.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/customer/sfmhy_1.jpg
// module id = MKFn
// module chunks = 15